import { useId } from "react";

import {
  AlertDialog,
  Button,
  Callout,
  Checkbox,
  Flex,
  Text,
} from "@radix-ui/themes";

export interface LiquidateAllDialogPresentationProps {
  open: boolean;
  openCount: number;
  hiddenByFilterCount: number;
  cancelOrders: boolean;
  submitting: boolean;
  errorMessage?: string;
  confirmDisabled: boolean;
  confirmLabel: string;
  onOpenChange: (open: boolean) => void;
  onCancelOrdersChange: (checked: boolean) => void;
  onConfirm: () => void;
}

export const LiquidateAllDialogPresentation = ({
  open,
  openCount,
  hiddenByFilterCount,
  cancelOrders,
  submitting,
  errorMessage,
  confirmDisabled,
  confirmLabel,
  onOpenChange,
  onCancelOrdersChange,
  onConfirm,
}: LiquidateAllDialogPresentationProps) => {
  const cancelOrdersId = useId();
  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Content maxWidth="28rem">
        <AlertDialog.Title>Liquidate all positions?</AlertDialog.Title>
        <AlertDialog.Description size="2" mb="3" color="gray">
          This immediately closes every open position on this account (
          {openCount} position{openCount === 1 ? "" : "s"}). It is not a draft
          ticket.
        </AlertDialog.Description>
        {hiddenByFilterCount > 0 ? (
          <Text size="2" mb="3">
            This includes {hiddenByFilterCount} position
            {hiddenByFilterCount === 1 ? "" : "s"} hidden by the current filter.
          </Text>
        ) : null}
        {errorMessage ? (
          <Callout.Root color="red" size="1" mb="3">
            <Callout.Text>{errorMessage}</Callout.Text>
          </Callout.Root>
        ) : null}
        <Flex asChild align="center" gap="2" mb="4">
          <label htmlFor={cancelOrdersId}>
            <Checkbox
              id={cancelOrdersId}
              size="1"
              checked={cancelOrders}
              disabled={submitting}
              onCheckedChange={(next) => onCancelOrdersChange(next === true)}
            />
            <Text size="2">Cancel open orders for these symbols</Text>
          </label>
        </Flex>
        <Flex gap="2" justify="end">
          <AlertDialog.Cancel>
            <Button
              type="button"
              variant="soft"
              color="gray"
              disabled={submitting}
            >
              Cancel
            </Button>
          </AlertDialog.Cancel>
          <Button
            type="button"
            color="red"
            disabled={confirmDisabled}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
};
